import * as React from 'react';

import { CHATBOT_ID } from '../constants/chatbotId';
import { useApplicationContext } from '../utils/applicationContext';

/**
 * Доступен ли реплай в чате с переданным chatId,
 * проверяется по RS-настройке chats.replies.nonReplyableChatIds
 */
export const useIsReplyableChat = (chatId: string): boolean => {
  const { config } = useApplicationContext();

  return React.useMemo(() => {
    const nonReplyableChatPatterns = config.get<string[] | null>('chats.replies.nonReplyableChatIds') ?? [CHATBOT_ID];

    return (
      Boolean(chatId) &&
      !nonReplyableChatPatterns.some(pattern => {
        try {
          return new RegExp(pattern).test(chatId);
        } catch {
          return false;
        }
      })
    );
  }, [config, chatId]);
};
